import React from "react";



export default function CompletedStudents() {
    return (
        <div>
            <h4><b>Completed Students</b></h4>
        </div>
    )
}
